import React from 'react';
import {InPageAlert} from '@snsw-gel/react';
import TollAccountType from '../../types/tollAccountType';

interface SuccessfulUnlinkAlertProps {
    readonly tollAccountType: TollAccountType;
}

const SuccessfulUnlinkAlert: React.FC<SuccessfulUnlinkAlertProps> = ({tollAccountType}) => {
    let title: string;
    let alertId: string;
    switch (tollAccountType) {
        case TollAccountType.Personal:
            title = 'Personal toll account';
            alertId = 'personal-toll-alert-unlink';
            break;
        case TollAccountType.Business:
            title = 'Business toll account';
            alertId = 'business-toll-alert-unlink';
            break;
        case TollAccountType.Mixed:
            title = 'Mixed personal toll account';
            alertId = 'mixed-toll-alert-unlink';
            break;
    }

    return <InPageAlert
        variant='success'
        title={`${title} removed`}
        id={alertId}
    />;
};

export default SuccessfulUnlinkAlert;
